import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {SwipeInteractionEvents} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionEvents';
import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {WinPresentationView} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationView';
import {BetlevelMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';

export class WinPresentationIndividualState extends ModuleState<WinPresentationView, WinPresentationModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
		this.stopWinPresentation();
		this.view.forceKillWinNumbers();
	}

	protected setupEvents(): void {
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelSpinningStarted);
		this.on(SwipeInteractionEvents.DRAGGING_STARTED, this.onSwipeInteractionStarted);
		this.on(BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
		this.on(WinPresentationEvents.COUNTUP_FINISHED, this.onCountupFinished);
	}

	protected onCountupFinished(): void {

	}

	protected onBetValueUpdated(): void {
		this.module.gotoState(WinPresentationModule.BASIC);
	}

	protected onReelSpinningStarted(): void {
		this.module.gotoState(WinPresentationModule.BASIC);
	}

	protected onSwipeInteractionStarted(): void {
		this.view.killCurrentWinPresentation();
		this.module.gotoState(WinPresentationModule.BASIC);
	}

	protected stopWinPresentation(): void {
		this.emitDelayed(WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED);
		this.view.killCurrentWinPresentation();
		this.view.forceKillWinNumbers();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationIndividualState.ts